/**
 *
 * TextValue
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import ClassNames from 'classnames';
import Colors from 'utils/colors';

const styles = () => ({
  text: {
    fontSize: 17,
    color: Colors.primary,
  },
  label: {
    fontWeight: 500,
    marginRight: 10,
  },
});

function TextValue({ label, value, classes }) {
  return (
    <Grid item container direction="row" xs={12}>
      <Typography className={ClassNames(classes.text, classes.label)}>
        {label}:
      </Typography>
      <Typography className={classes.text}>{value}</Typography>
    </Grid>
  );
}

TextValue.propTypes = {
  classes: PropTypes.object,
  label: PropTypes.string,
  value: PropTypes.string,
};

export default withStyles(styles)(TextValue);
